package com.eladfinish.bible.contest.ui.extensions

import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/**
 * Height of the system navigation bar that the screen content is drawn behind.
 *
 * The screens are edge-to-edge: with no bottom bar (the ad banner) they extend behind the
 * navigation bar, so the end of every scrollable list and every control pinned to the bottom
 * must be padded by this value. It is 0 when the ad banner sits above the navigation bar, when
 * the keyboard is open (the Scaffold already lifted the content above it) and on web.
 */
// Not static: it changes on every frame of the keyboard animation, and only its readers should recompose.
val LocalNavigationBarInset: ProvidableCompositionLocal<Dp> = compositionLocalOf { 0.dp }

/** Pads the bottom by [LocalNavigationBarInset]. Place it inside the scroll modifier of a scrolling column. */
@Composable
fun Modifier.navigationBarInsetPadding(): Modifier = padding(bottom = LocalNavigationBarInset.current)

/** [contentPadding] for a lazy list or grid, with [LocalNavigationBarInset] added to the bottom. */
@Composable
fun navigationBarContentPadding(
    horizontal: Dp = 0.dp,
    top: Dp = 0.dp,
    bottom: Dp = 0.dp,
): PaddingValues = PaddingValues(
    start = horizontal,
    top = top,
    end = horizontal,
    bottom = bottom + LocalNavigationBarInset.current,
)
